import { Box, IconButton, Tooltip } from '@mui/material'
import { Icon } from '@media-components'
import { CustomStyles, getStyles } from '@utils/styles'
import defaultStyles, { StylesClassNames } from '../styles'

interface AudioControlsProps {
  isPlaying: boolean
  allowSkip?: boolean
  disabled?: boolean
  buffering?: boolean
  onPlayClick: () => void
  onPauseClick: () => void
  onSkipForwardClick: () => void
  onSkipBackwardClick: () => void
  skipDuration: number
  csx?: CustomStyles<StylesClassNames>
}

function AudioControls({
  isPlaying,
  allowSkip = false,
  disabled = false,
  buffering = false,
  onPlayClick,
  onPauseClick,
  onSkipForwardClick,
  onSkipBackwardClick,
  skipDuration,
  csx,
}: AudioControlsProps) {
  const styles = getStyles(defaultStyles, csx)

  const showSkipBtn = !disabled && allowSkip && !buffering
  const showPause = isPlaying && !disabled

  return (
    <Box {...styles('controlWrapper')}>
      {/* skip backwards */}
      {showSkipBtn && (
        <Tooltip title={`- ${skipDuration}sec`}>
          <IconButton
            {...styles('hideOnSmallScreen')}
            onClick={onSkipBackwardClick}
          >
            <Icon iconName="Backward" colorValues="text.primary" />
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title={showPause ? 'Pause' : 'Play'}>
        <IconButton
          onClick={isPlaying ? onPauseClick : onPlayClick}
          disabled={disabled}
          mode="light"
        >
          <Icon
            iconName={showPause ? 'PauseCircle' : 'PlayCircle'}
            colorValues="text.primary"
          />
        </IconButton>
      </Tooltip>

      {/* skip forwards */}
      {showSkipBtn && (
        <Tooltip title={`+ ${skipDuration}sec`}>
          <IconButton
            {...styles('hideOnSmallScreen')}
            onClick={onSkipForwardClick}
          >
            <Icon iconName="Forward" colorValues="text.primary" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  )
}

export default AudioControls
